export function isEquatable(instance) {
  return 'equals' in instance;
}
